import {minValue, numeric, required} from "vuelidate/lib/validators";
import { todayStr } from "@/utils/dateFormat";
import {Request} from "../Requests/request";
import {ModelObject} from "@/pages/Common/modelObject";

export const RaidStatus = Object.freeze({
    PLANNED: 1,
    SUCCESS: 2,
    FAIL: 3,
});

export class Raid extends ModelObject {

    constructor(initObjectParams) {
        super(initObjectParams)

        this.id = null;
        this.status = RaidStatus.PLANNED;
        this.address = null;
        this.lat = null;
        this.lon = null;
        this.description = null;
        this.comment = null;
        this.plannedAt = todayStr();
        this.actualDate = null;
        this.caughtCount = 0;
        this.plannedCount = 0;
        this.request = null;
        this.requestContractorId = null;

        this.addressObject = {};

        this.statusObject = {};

        this.animalsToRelease = [];
        this.animalObjectsToRelease = [];
        this.alreadyReleasedAnimals = [];

        this.applyInitObjectParams(initObjectParams)
    }

    static get modelName() {
        return 'Raid'
    }

    static get validations() {
        return {
            status: { required },
            request: { required },
            address: { required },
            description: {},
            comment: {},
            plannedAt: { required },
            actualDate: { },
            plannedCount: { numeric, minValue:minValue(0) },
            caughtCount: { numeric, minValue:minValue(0) },
            animalsToRelease: {},
            lat: {},
            lon: {}
        }
    }

    static get validationFieldLabels() {
        return {
            status: 'Статус',
            comment: 'Комментарий',
            plannedCount: 'К отлову',
            caughtCount: 'Поймано',
            address: 'Адрес',
            animalsToRelease: 'Животные на выпуск',
        }
    }

    static get mapping() {
        return {
            plannedAt: 'planned_at',
            actualDate: 'actual_date',
            plannedCount: 'planned_count',
            caughtCount: 'caught_count',
            animalsToRelease: 'animals_to_release',
        }
    }

    static get label() {
        return 'Рейд'
    }

    label() {
        return 'Рейд'
    }

    static get newLabel() {
        return 'Новый рейд'
    }

    objectLabel() {
        return `${Raid.label} №${this.id}`
    }

    objectDescription() {
        let description = '';
        if (this.plannedAt) { description += `Запланирован ${this.plannedAt}` }
        return description
    }

    get addressHumanReadable() {
        return this.id && this.addressObject ? this.addressObject['short_text'] : null
    }

    get isCompleted() {
        return this.status === RaidStatus.SUCCESS || this.status === RaidStatus.FAIL;
    }

    get coordinates() {
        return { lat: this.lat, lon: this.lon }
    }
}